import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoService } from '../../@core/services/cognito.service';
import { UserService } from '../../@core/services/user.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-open-connect',
  templateUrl: './open-connect.component.html',
  styleUrls: ['./open-connect.component.css']
})
export class OpenConnectComponent implements OnInit {

  constructor(public route: ActivatedRoute, public router: Router, public cognitoService: CognitoService, public userService: UserService) {
    localStorage.clear();
  }
  params = '';
  error = '';
  loading = true;
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.params = params.openToken;
      this.userService.verifyOpenToken(this.params).subscribe(response => {
        this.route.queryParams.subscribe(queryParams => {
          if (queryParams.rememberMe !== undefined) {
            localStorage.setItem('rememberMe', queryParams.rememberMe);
            this.cognitoService.initCognitoUserPool(queryParams.rememberMe)
          }
          const deviceKey = queryParams.deviceKey;
          const deviceGroupKey = queryParams.deviceGroupKey;
          environment.cognitoConf.cognito.cognitoClientPoolId = "116q9s5qgup8a08o1n8h8km43q";
          this.cognitoService.poolData = {
            UserPoolId: environment.cognitoConf.cognito.cognitoPoolId,
            ClientId: environment.cognitoConf.cognito.cognitoClientPoolId
          };
          this.cognitoService.authWithTokens({ ...response, deviceKey, deviceGroupKey }).then(resp => {
            this.loading = false;
            if (resp) {
              this.router.navigate(['builder']);
            } else {
              this.error = 'Error found please try again';
            }
          });
        })
      },
        err => {
          this.loading = false;
          this.error = err.error.message;
        });
    });
  }

}
